import React from 'react';
import './HoldTimer.scss';

const TOTAL_DURATION = 10 * 60; // 10 minutes in seconds
const CIRCLE_RADIUS = 54;
const CIRCLE_CIRCUMFERENCE = 2 * Math.PI * CIRCLE_RADIUS;

class HoldTimer extends React.Component {
  constructor(props) {
    super(props);
    const duration = props.durationSeconds || TOTAL_DURATION;
    this.state = {
      remainingSeconds: duration,
      totalSeconds: duration
    };
    this._interval = null;
  }

  componentDidMount() {
    if (this.props.onTick) {
      this.props.onTick(this.state.remainingSeconds);
    }
    this._interval = setInterval(() => {
      this.setState(function (prevState) {
        const next = prevState.remainingSeconds - 1;
        if (next <= 0) {
          clearInterval(this._interval);
          this._interval = null;
          if (this.props.onExpired) {
            this.props.onExpired();
          }
          return { remainingSeconds: 0 };
        }
        return { remainingSeconds: next };
      }, function () {
        if (this.props.onTick) {
          this.props.onTick(this.state.remainingSeconds);
        }
      }.bind(this));
    }, 1000);
  }

  componentWillUnmount() {
    if (this._interval) {
      clearInterval(this._interval);
      this._interval = null;
    }
  }

  formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    const mm = mins < 10 ? '0' + mins : '' + mins;
    const ss = secs < 10 ? '0' + secs : '' + secs;
    return mm + ':' + ss;
  }

  render() {
    const { remainingSeconds, totalSeconds } = this.state;
    const progress = remainingSeconds / totalSeconds;
    const strokeOffset = CIRCLE_CIRCUMFERENCE * (1 - progress);

    return (
      <div className="hold-timer" role="timer" aria-label="Session timer">
        <div className="hold-timer__card">
          <div className="hold-timer__label">Session will expire in</div>
          <div className="hold-timer__circle-wrap">
            <svg
              className="hold-timer__svg"
              width="130"
              height="130"
              viewBox="0 0 120 120"
            >
              {/* Background track */}
              <circle
                className="hold-timer__track"
                cx="60"
                cy="60"
                r={CIRCLE_RADIUS}
                fill="none"
                strokeWidth="6"
              />
              {/* Progress ring */}
              <circle
                className="hold-timer__progress"
                cx="60"
                cy="60"
                r={CIRCLE_RADIUS}
                fill="none"
                strokeWidth="6"
                strokeDasharray={CIRCLE_CIRCUMFERENCE}
                strokeDashoffset={strokeOffset}
                strokeLinecap="round"
                transform="rotate(-90 60 60)"
              />
            </svg>
            <div className="hold-timer__time">
              {this.formatTime(remainingSeconds)}
            </div>
          </div>
        </div>
        <div className="hold-timer__pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          <span>{this.formatTime(remainingSeconds)}</span>
        </div>
      </div>
    );
  }
}

export default HoldTimer;
